var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.925781 5.01904L3.96926 8.08154L10.9258 1.08154","stroke":"white","strokeWidth":"2"}));
}

Check.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none"};

module.exports = Check;

Check.default = Check;
